<script lang="ts">
  import { cn } from '$lib/utils';

  export let title: string;
  export let showTitle = false;
  export let active = false;
  export let size: 'sm' | 'md' = 'sm';
  export let img: string;

  let className: string | undefined = undefined;
  export { className as class };
</script>

<div class="m-1">
  {#if !$$restProps.href}
    <input
      type="checkbox"
      on:change
      on:mouseenter
      on:mouseleave
      on:click
      on:focus
      on:blur
      {...$$restProps}
      class={cn(
        'visually-hidden',
        '[&:checked+label]:ring-accent [&:checked+label]:focus-visible:ring-accent/40',
        '[&:checked~p]:text-accent-contrast',
        '[&:focus-visible+*]:ring-accent/40',
        '[&:disabled+label]:opacity-40 [&:disabled~p]:opacity-40 [&:disabled+label:hover]:cursor-not-allowed'
      )}
    />
  {/if}

  <svelte:element
    this={$$restProps.href ? 'a' : 'label'}
    for={$$restProps.id}
    style="background-image: url({img}); background-position:center"
    class={cn(
      'block rounded-sm cursor-pointer border-none bg-cover bg-no-repeat outline-none ring-1 ring-offset-2 ring-offset-background transition-all motion-reduce:transition-none focus-visible:ring-4',
      active
        ? 'ring-accent focus-visible:ring-accent/40'
        : 'ring-primary/14 focus-visible:ring-accent/40',
      className
    )}
    {...$$restProps}
  >
    {#if !showTitle}
      <span class="visually-hidden">
        {title}
      </span>
    {/if}
  </svelte:element>

  {#if showTitle}
    <p
      class={cn(
        'mt-2 text-sm transition-all motion-reduce:transition-none',
        active && 'text-accent-contrast',
        size === 'md' && 'mt-2.5 w-full text-center'
      )}
    >
      {title}
    </p>
  {/if}
</div>
